import { render } from "./SelectLanguage.vue?vue&type=template&id=6dfca61a&scoped=true"
import script from "./SelectLanguage.vue?vue&type=script&lang=js"
export * from "./SelectLanguage.vue?vue&type=script&lang=js"

import "./SelectLanguage.vue?vue&type=style&index=0&id=6dfca61a&scoped=true&lang=css"

import exportComponent from "/var/www/frontdash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfca61a"]])

export default __exports__